export default function ProductProblem({ product }) {
  return (
    <section className="product-block">
      <div className="product-block__head">/ The problem</div>
      <h4 className="product-block__title">What it solves</h4>
      <p className="product-problem">{product.problem}</p>
    </section>
  );
}
